// @flow

import React, { Component } from 'react';
import moment from 'moment';
import radium from 'radium';
import styler from 'react-styling';
import 'fullcalendar/dist/fullcalendar.min.css';
import breakpoints from '../../css/breakpoints';

const style = styler `
CalendarWrapper
  margin-top: 40px
  margin-bottom: 30px
  @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
    margin-top: 20px
Title1
  text-align: left
  display: none
  width: 100%
  margin-bottom: 20px
  @media screen and (max-width: ${breakpoints.SMALL_AND_ABOVE}px)
    display: inline-block
    margin-bottom: 5px
Title2
  float: left
  margin-left: 20px
  display: inline
  @media screen and (max-width: ${breakpoints.SMALL_AND_ABOVE}px)
    display: none
Date
  font-size: 30px
  color: #666
  font-weight: 400
  float: left
  @media screen and (max-width: ${breakpoints.SMALL_AND_ABOVE}px)
    font-size: 25px
FcViewButton
  @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
    padding: 10px 8px
FcDirectionButton
  @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
    padding: 10px 7px
`;

class CalendarHeader extends Component {
  props: {
    calendarView: string,
    startDate: {
      format: any,
      month: any,
    },
    endDate: Date,
    scrollCalendar: any,
    setCalendarView: any,
    languagedata: Object,
    weekView: boolean,
    monthView: boolean,
    dayView: boolean,
  }

  renderTitle = () => {
    if (this.props.calendarView === 'listDay') {
      const title = this.props.startDate.format('LL');
      return title;
    } else if (this.props.calendarView === 'month') {
      const title = this.props.startDate.format('MMMM YYYY');
      return title;
    }
    const start = this.props.startDate.format('MMM D');
    const realEnd = moment(this.props.endDate).subtract(1, 'days');
    const end = this.props.startDate.month() === realEnd.month() ? (
      realEnd.format('D, YYYY')
    ) : (
      realEnd.format('MMM D, YYYY')
    );
    const title = `${start}-${end}`;
    return title;
  }

  render() {
    const btnMonthClasses = this.props.calendarView === 'month' ? (
      'fc-month-button fc-button fc-state-default fc-state-active'
    ) : (
      'fc-month-button fc-button fc-state-default'
    );
    const btnWeekClasses = this.props.calendarView === 'listWeek' ? (
      'fc-listWeek-button fc-button fc-state-default fc-state-active'
    ) : (
      'fc-listWeek-button fc-button fc-state-default'
    );
    const btnDayClasses = this.props.calendarView === 'listDay' ? (
      'fc-listDay-button fc-button fc-state-default fc-state-active'
    ) : (
      'fc-listDay-button fc-button fc-state-default'
    );
    return (

      <div className="fc fc-unthemed fc-ltr" style={style.CalendarWrapper}>
        <div className="fc-toolbar">
          <div style={style.Title1} className="calendartitle">
            <span style={style.Date}>{this.renderTitle()}</span>
          </div>
          <div className="fc-left">
            <div className="fc-button-group">
              <button
                style={style.FcDirectionButton}
                className="fc-prev-button fc-button fc-state-default"
                onClick={() => this.props.scrollCalendar('prev')}
              >
                <span className="fc-icon fc-icon-left-single-arrow">{''}</span>
              </button>
              <button
                style={style.FcDirectionButton}
                className="fc-next-button fc-button fc-state-default"
                onClick={() => this.props.scrollCalendar('next')}
              >
                <span className="fc-icon fc-icon-right-single-arrow">{''}</span>
              </button>
            </div>
          </div>
          <div style={style.Title2} className="calendartitle2">
            <span style={style.Date}>{this.renderTitle()}</span>
          </div>
          <div className="fc-right">
            <div className="fc-button-group">
              {this.props.monthView ?
                <button
                  style={style.FcViewButton}
                  className={btnMonthClasses}
                  onClick={() => this.props.setCalendarView('month')}
                >{this.props.languagedata.month}</button> : null}
              {this.props.weekView ?
                <button
                  style={style.FcViewButton}
                  className={btnWeekClasses}
                  onClick={() => this.props.setCalendarView('listWeek')}
                >{this.props.languagedata.week}</button> : null}
              {this.props.dayView ?
                <button
                  style={style.FcViewButton}
                  className={btnDayClasses}
                  onClick={() => this.props.setCalendarView('listDay')}
                >{this.props.languagedata.day}</button> : null}
              <button
                style={style.FcViewButton}
                className="fc-listDay-button fc-button fc-state-default"
                onClick={() => this.props.setCalendarView('today')}
              >{this.props.languagedata.today}</button>
            </div>
          </div>
          <div className="fc-clear">{''}</div>
        </div>
      </div>
    );
  }
}

export default radium(CalendarHeader);



// WEBPACK FOOTER //
// ./src/js/Components/CalendarHeader.js